export default "__VITE_ASSET__Bo0gPxxK__"